export const TRANSCRIPTION_DISABLED = 'TRANSCRIPTION_DISABLED';
export const TRANSCRIPTION_LANGUAGE_COPIED = 'TRANSCRIPTION_LANGUAGE_COPIED';
export const SUBTITLES_HIDDEN = 'SUBTITLES_HIDDEN';
